<template>
    <div>
        <button ref="record" v-on:click="record()" v-if="!recording">Grabar</button>
        <button ref="parar" v-on:click="record()" v-if="recording">Parar</button>
        <button ref="play" v-on:click="play()" v-if="hasAudio">Reproducir</button>
    </div>
</template>
<style scoped>
</style>
<script>
    function createAudioFromBlob(audioBlob){
        const audioUrl = URL.createObjectURL(audioBlob);
        const audio = new Audio(audioUrl);
        const play = () => {
            audio.play();
        };

        return { audioBlob, audioUrl, play };
    }
    const recordAudio = () => {
    return new Promise(resolve => {
        navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
            const mediaRecorder = new MediaRecorder(stream);
            const audioChunks = [];

            mediaRecorder.addEventListener("dataavailable", event => {
                audioChunks.push(event.data);
            });

            const start = () => {
                mediaRecorder.start();
            };

            const stop = () => {
                return new Promise(resolve => {
                    mediaRecorder.addEventListener("stop", () => {
                        const audioBlob = new Blob(audioChunks);
                        resolve(createAudioFromBlob(audioBlob));
                    });

                    mediaRecorder.stop();
                });
            };

            resolve({ start, stop });
        });
    });
    };
    var recorder = null;
    export default {
        props: ['type', 'page', 'number'],
        computed: {
            dbId(){
                return `${this.type}-${this.page}-${this.number}`
            },
            hasAudio(){
                return this.audio !== null;
            }          
        },
        data () {
            return {
                recording: false,
                audio: null,
                recordTimeout: null,
            }
        },
        methods: {
            async stop() {
                this.audio = await recorder.stop();
                var thisRef = this;
                if (this.recordTimeout !== null){
                    clearTimeout(this.recordTimeout);
                    this.recordTimeout = null;
                }
                this.$db.sounds.put({
                    id: this.dbId,
                    blob: this.audio.audioBlob
                }).catch(function(error){
                    console.log("error uploading file" + error);
                    thisRef.recording = false;
                }).then(function(){
                    thisRef.recording = false;
                });
            },
            async record(){
                if (this.recording) {
                    await this.stop();
                }
                else {
                    var thisRef = this;
                    recorder = await recordAudio();
                    this.recordTimeout = setTimeout(function(){
                        if (thisRef.recording){
                            thisRef.stop();
                        }
                    }, 10000);
                    this.recording = true;
                    recorder.start();
                }
            },
            play(){
                if (this.audio !== null){
                    this.audio.play();
                }
            }
        },
        async created() {
            var audio = await this.$db.sounds.get({
                id: this.dbId,
            }).catch(function(error){
                console.log("error uploading file" + error);
            });
            if (audio === undefined) return;
            this.audio = createAudioFromBlob(audio.blob);    
        },
    }
</script>
